<template>
  <div class="flex flex-col items-center px-5 lg:px-0">
    <NoResults
      class="mb-10 lg:mb-14"
      :search-term="searchTerm || '*'"
    />
    <div v-if="canShowContent">
      <RenderContent :content="internalCmsContent" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { COMPONENTS } from '~~/constants/cms';

// Mounted only when a listing has no products, so the department block is fetched only then.
// `*` for an empty query, as the Typesense adapter sends it and SearchResultsInner shows it.
defineOptions({ name: 'CtNoResults' });

defineProps<{
  searchTerm: string;
}>();

const { loadComponent, internalCmsContent, canShowContent } = useInternalCms(COMPONENTS.SHOP_BY_DEPARTMENT.SLUG);

onMounted(() => {

  if (!canShowContent.value) {

    loadComponent();

  }

});
</script>
